import React, { useEffect } from 'react';
import { isNil, range } from 'lodash';
import RuleCard from './RuleCard';
import Input from 'shared/inputs/BaseInput';
import Select from 'shared/inputs/BaseSelect';
import { TAKE_LAST_CHARACTERS, TAKE_FIRST_CHARACTERS } from '../consts';
import useRulesContext from '../context';

const directions = [{ value: 'first' }, { value: 'last' }];

const TakeNCharacters = () => {
  const {
    count, ruleTypeId, onCountChange, onRuleTypeChange, dispatch,
  } = useRulesContext();

  const isActive = ruleTypeId === TAKE_FIRST_CHARACTERS || ruleTypeId === TAKE_LAST_CHARACTERS;

  useEffect(() => {
    if (!isActive) {
      return;
    }
    dispatch('setValid', !!count);
  }, [count]);

  const onClick = () => {
    if (!isActive) {
      dispatch('reset');
    }
    onRuleTypeChange(TAKE_FIRST_CHARACTERS);
  };

  // First/Last selector
  const lastFirstValue = ruleTypeId === TAKE_LAST_CHARACTERS ? 'last' : 'first';
  const onFirstLastChange = ({ value }) => onRuleTypeChange(
    value === 'last' ? TAKE_LAST_CHARACTERS : TAKE_FIRST_CHARACTERS,
  );

  return (
    <RuleCard isActive={isActive} onClick={onClick}>
      Take
      {isActive && (
        <>
          <Select
            data={directions}
            textField='value'
            value={lastFirstValue}
            onChange={onFirstLastChange}
            keyOnly
            clearButton={false}
          />
          <Input autoFocus customInput='numeric' min={1} value={count} onChange={onCountChange} />
        </>
      )}
      {!isActive && <span className='value-placeholder'>first/last N</span>}
      characters
    </RuleCard>
  );
};

const TakeNCharactersPreview = () => {
  const { count, ruleTypeId } = useRulesContext();

  return (
    <>
      {(ruleTypeId === TAKE_LAST_CHARACTERS || isNil(count)) && range(0, 5).map((ind) => (
        <div key={`preview-char-${ind}`} className='preview-char' />
      ))}
      {range(0, count).map((ind) => (
        <div key={`preview-char-${ind}`} className='preview-char included-char' />
      ))}
      {(ruleTypeId === TAKE_FIRST_CHARACTERS || isNil(count)) && range(0, 5).map((ind) => (
        <div key={`preview-char-${ind}`} className='preview-char' />
      ))}
    </>
  );
};

export default {
  RuleComponent: TakeNCharacters,
  PreviewComponent: TakeNCharactersPreview,
  ruleTypesIds: [TAKE_FIRST_CHARACTERS, TAKE_LAST_CHARACTERS],
};
